<template>
    <section v-if="visible" class="staff-section-box">
        <el-dialog title="组员分数汇总" :visible="visible" width="1100px" @close="closeDialog">
            <el-table :data="groupAssessmentList" :default-sort = "{prop: 'date', order: 'descending'}">
                <el-table-column header-align="center" align="center" prop="staff.user_name" sortable label="组员" width="150">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="data" sortable label="全组考勤" width="150">
                    <template slot-scope="scope">
                        {{setClockingInScore(scope)}}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="data" sortable label="全组时间管理" width="150">
                    <template slot-scope="scope">
                        {{serTimeManagementScore(scope)}}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="position_name" sortable label="全组工作达成" width="150">
                    <template slot-scope="scope">
                        {{getCustomDataScore('工作达成',scope)}}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="data" sortable label="全组工作能力" width="150">
                    <template slot-scope="scope">
                        {{getCustomDataScore('工作能力',scope)}}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="data" sortable label="全组管理能力" width="150">
                    <template slot-scope="scope">
                        {{getCustomDataScore('管理能力',scope)}}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="staff.position_name" sortable label="岗位" width="150">
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDialog">确 定</el-button>
            </div>
        </el-dialog>
    </section>
</template>
<script>
export default {
    data(){
        return {
            tableData:[]
        }
    },
    props:['visible','groupAssessmentList'],
    created () {
    },
    methods:{
        closeDialog(){          //关闭
            this.$emit('close')
        },
        getCustomDataScore (name,scope) {
            let score = 0
            scope.row.has_many_custom_data.forEach((item) => {
                if(item.parent_id === '00000000-0000-0000-0000-000000000000' && item.item_name === name){
                    score = item.score
                }
            })
            return score
        },
        setClockingInScore (scope) {
            const { regular_attendance, nine_minute, punch_miss, meal_overtime, lunch_overtime } = scope.row
            const { shift } = scope.row.template
            if (shift == 1) { // 夜班
                return ((Number(regular_attendance) + Number(nine_minute) + Number(punch_miss) + Number(meal_overtime)) / 4).toFixed(2)
            } else {
                return ((Number(regular_attendance) + Number(nine_minute) + Number(punch_miss) + Number(meal_overtime) + Number(lunch_overtime)) / 5).toFixed(2)
            }
        },
        serTimeManagementScore (scope) {
            // const { off_plan_overtime, breakfast_plan_score, lunch_plan_score } = scope.row
            // return (Number(off_plan_overtime) + Number(breakfast_plan_score) + Number(lunch_plan_score)).toFixed(2)
            return scope.row.off_plan_overtime
        }
    }
}
</script>
<style scoped>
    
</style>